import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { IoCardOutline } from 'react-icons/io5';
import LoadSpinner from '../Shared/ComponentLoading';
import { FormatDecimal } from '../Functions/NumberFormatter';

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, ChartDataLabels, Title, Tooltip, Legend);

const currencyOptions = { style: 'currency', currency: 'GBP' };

const DashboardAccounts = ({ fieldData, bankData, summaryLoading, accountsLoading }) => {
    const chartData = {
        labels: bankData.map((item) => item.accountId),
        datasets: [{
            label: 'Balance',
            backgroundColor: 'rgba(0, 128, 128, 0.8)',
            data: bankData.map((item) => item.balance),
            fill: true,
            datalabels: {
                color: '#111',
                align: 'top',
                anchor: 'end',
                display: true,
                formatter: (value) => FormatDecimal(value),
                font: { weight: 'normal' },
            },
        }],
    };

    return (
        <Row>
            <Col xs="12">
                <Card className="mt-2">
                    <CardHeader className="cd-header">
                        <div className="d-flex">
                            <IoCardOutline size={24} style={{ color: '#111' }} />&nbsp;&nbsp;<div>Accounts</div>
                        </div>
                    </CardHeader>
                    <CardHeader className="pt-1 pb-1 text-center">
                        {summaryLoading ? <LoadSpinner /> : (
                            <>
                                <Row>
                                    <Col className="text-muted cd-subheader">Total Balance</Col>
                                    <Col className="text-muted cd-subheader">Current Accounts</Col>
                                    <Col className="text-muted cd-subheader">Credit Cards</Col>
                                    <Col className="text-muted cd-subheader">Savings</Col>
                                </Row>
                                <Row className="pt-2 pb-2">
                                    <Col className="cd-value">{fieldData.bankTotal?.toLocaleString('GB-en', currencyOptions)}</Col>
                                    <Col className="cd-value">{fieldData.ddTotal?.toLocaleString('GB-en', currencyOptions)}</Col>
                                    <Col className="cd-value">{fieldData.ccTotal?.toLocaleString('GB-en', currencyOptions)}</Col>
                                    <Col className="cd-value">{fieldData.saTotal?.toLocaleString('GB-en', currencyOptions)}</Col>
                                </Row>
                            </>
                        )}
                    </CardHeader>
                    <CardBody>
                        {accountsLoading ? <LoadSpinner /> : <Bar data={chartData} style={{ maxHeight: '300px' }} />}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default DashboardAccounts;
